import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Toast, ToastVariant } from './toast.model';

const BORDER_CLASSES: Record<ToastVariant, string> = {
  error: 'border-error-container',
  success: 'border-secondary-container',
  warning: 'border-tertiary-container',
};

const ICON_NAMES: Record<ToastVariant, string> = {
  error: 'warning-circle',
  success: 'check-circle',
  warning: 'warning-triangle',
};

const ICON_CLASSES: Record<ToastVariant, string> = {
  error: '!text-error',
  success: '!text-secondary',
  warning: '!text-tertiary',
};

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './toast.component.html',
})
export class ToastComponent {
  @Input({ required: true }) toast!: Toast;
  @Output() close = new EventEmitter<void>();

  onActionClick(): void {
    this.toast.action?.onClick();
  }

  get borderClass(): string {
    return BORDER_CLASSES[this.toast.variant];
  }

  get iconName(): string {
    return ICON_NAMES[this.toast.variant];
  }

  get iconClass(): string {
    return ICON_CLASSES[this.toast.variant];
  }
}
